export default __webpack_public_path__ + "static/media/vAda.14098974.svg";